import { Divider } from 'antd'
import AntdAvatar from 'components/Avatar'
import Button from 'components/Button'
import RoutePath from 'components/RoutePath'
import CandidatesIcon from 'components/icons/CandidatesIcon'
import LeftArrow from 'components/icons/LeftArrow'
import SchoolIcon from 'components/icons/SchoolIcon'
import StarsIcon from 'components/icons/StarsIcon'
import {
  CollegeName,
  Container,
  FlexWrap,
  GreyMedium,
  GreySmall,
  HeaderFlex,
  PaddedDiv,
  TopHeader,
} from 'modules/Roles/Partials/ViewCollegeDetails/Partials/Styles/style'
import React, { useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom'

const Header = ({
  instituteCampusDetails,
  setCreaterDriveDrawer,
  instituteDetails,
}) => {
  const params = useParams()
  const candidateCount = params?.candidates
  const [collegInfo, setCollegInfo] = useState([])

  const paths = [
    {
      from: 'Role',
      path: '/rolePage',
    },
    {
      from: 'View Role',
      path: `/roles/${params?.jobId}/view-role`,
    },
  ]

  useEffect(() => {
    const headerData = [
      {
        icon: <StarsIcon />,
        text: 'College Rank:',
        value: instituteCampusDetails?.institute?.ranking,
      },
      {
        icon: <CandidatesIcon />,
        text: 'Cand. Applied:',
        value: candidateCount,
      },
      {
        icon: <SchoolIcon />,
        text: 'Total Courses:',
        value: instituteCampusDetails?.course?.length
          ? instituteCampusDetails?.course?.length
          : 0,
      },
    ]
    setCollegInfo(headerData)
  }, [instituteCampusDetails, instituteDetails])

  return (
    <Container column>
      <PaddedDiv column>
        <TopHeader>
          <Link to={`/roles/${params?.jobId}/view-role`}>
            <LeftArrow />
          </Link>
          <RoutePath
            fromArr={paths}
            on={'View College Details'}
            path="/rolePage"
          />
        </TopHeader>
        <HeaderFlex spaceBetween>
          <AntdAvatar
            src={instituteCampusDetails?.campusLogoUrl}
            size={86}
            font={'30px'}
            IconName={instituteCampusDetails?.campusName?.charAt(0)}
          />
        </HeaderFlex>
      </PaddedDiv>
      <FlexWrap gap="6px" baseLine>
        <CollegeName>{`${instituteCampusDetails?.campusName}`}</CollegeName>
        <GreySmall>{`${instituteCampusDetails?.city}, ${instituteCampusDetails?.state}`}</GreySmall>
      </FlexWrap>
      <FlexWrap padding="0 25px">
        {collegInfo?.map((item, index) => (
          <FlexWrap padding="0" key={index + item?.value} alignCenter gap="5px">
            {item?.icon}{' '}
            <GreyMedium>
              {item?.text} <span>{item?.value}</span>
            </GreyMedium>
            {collegInfo?.length != index + 1 ? (
              <Divider type="vertical" />
            ) : null}
          </FlexWrap>
        ))}
      </FlexWrap>
    </Container>
  )
}

export default Header
